import React, { useState,useEffect } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { Button,Label,Input,Modal,ModalHeader } from 'reactstrap';
import Table from 'react-bootstrap/Table';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

export default function Reports() {
    const navigate = useNavigate();
    const[account, setAccount] = useState('');
    const [type,setType] = useState('')
    const[claims, setClaims] = useState([]);
    const[magistrate,setMagistrate] = useState('')
    const[lawyer,setLawyer] = useState('');
    const[police,setPolice] = useState("")
    const [query, setQuery] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [selectedSuggestion, setSelectedSuggestion] = useState(null);

    const [query1, setQuery1] = useState('');
    const [suggestions1, setSuggestions1] = useState([]);
    const [selectedSuggestion1, setSelectedSuggestion1] = useState(null);

    const [query2, setQuery2] = useState('');
    const [suggestions2, setSuggestions2] = useState([]);
    const [selectedSuggestion2, setSelectedSuggestion2] = useState(null);

    const [query3, setQuery3] = useState('');
    const [suggestions3, setSuggestions3] = useState([]);
    const [selectedSuggestion3, setSelectedSuggestion3] = useState(null);

     const [isOpen, setIsOpen] = useState(false);
    
        const toggleMenu = () => {
        setIsOpen(!isOpen);
      };
    


    const exportToPdf = () => {
        const doc = new jsPDF();
    
        // Add a title to the PDF
        doc.text("MOTOR CLAIMS REPORT", 20, 10);
    
        // Extract table headers and rows from the DOM
        const table = document.getElementById("dataTable");
        const headers = Array.from(
          table.querySelectorAll("thead tr th")
        ).map((header) => header.textContent);
    
        const rows = Array.from(table.querySelectorAll("tbody tr")).map((row) =>
          Array.from(row.querySelectorAll("td")).map((cell) => cell.textContent)
        );
    
        // Generate the PDF table
        doc.autoTable({
          head: [headers],
          body: rows,
          startY: 20,
        });
    
        // Save the PDF
        doc.save("MOTOR_CLAIMS_REPORT.pdf");
      };

    useEffect(() => {
        const user = localStorage.getItem('email'); // Retrieve email
        if (user) {
          setAccount(user)
        } else {
       
        }
      }, []);


      useEffect(()=>{

        const getType =async()=>{
            const res = await fetch(`https://panel.yunshuglobal.com:3063/api/getType?email=${account}`);
            const data = await res.json()
            setType(data.IsAdmin)
        }

        if(account){
            getType()
        }

      },[account])



    const toNew =()=>{
        navigate('/new-claim')
    }

    const toHome =()=>{
        navigate('/dashboard')
    }
    const toUsers =()=>{
      navigate('/users')
  }

      useEffect(()=>{

        const getClaims =async()=>{
            const res = await fetch(`https://panel.yunshuglobal.com:3063/api/getClaims?account=${account}`);
            const data = await res.json();
            setClaims(data)
        }

        const getAllClaims =async()=>{
            const res = await fetch(`https://panel.yunshuglobal.com:3063/api/getAllClaims`);
            const data = await res.json();
            setClaims(data)
        }        
        if(account){

            if(type == '0'){
                getClaims();
            }
            else if(type == '1'){
                getAllClaims();
            }
           
        }

      },[account,type])


      const handleChange = async (e) => {
        const value = e.target.value;
        setQuery(value);
    
        if (value.trim() === '') {
          setSuggestions([]);
          return;
        }
    
        try {
          const response = await fetch(`https://panel.yunshuglobal.com:3063/api/searchPolice?account=${account}&police=${value}`);
          const data = await response.json();
          setSuggestions(data);
        } catch (error) {
          console.error('Error fetching suggestions:', error);
        }
      };
    
      const handleSelect = (suggestion) => {
        setQuery(suggestion.name);
        setSelectedSuggestion(suggestion.Police);
        setSuggestions([]);
      };



      const handleChange1 = async (e) => {
        const value = e.target.value;
        setQuery1(value);
    
        if (value.trim() === '') {
          setSuggestions1([]);
          return;
        }
    
        try {
          const response = await fetch(`https://panel.yunshuglobal.com:3063/api/searchLawyer?account=${account}&lawyer=${value}`);
          const data = await response.json();
          setSuggestions1(data);
        } catch (error) {
          console.error('Error fetching suggestions:', error);
        }
      };
    
      const handleSelect1 = (suggestion) => {
        setQuery1(suggestion.name);
        setSelectedSuggestion1(suggestion.Lawyer);
        setSuggestions1([]);
      };
      const handleChange2 = async (e) => {
        const value = e.target.value;
        setQuery2(value);
    
        if (value.trim() === '') {
          setSuggestions2([]);
          return;
        }
    
        try {
          const response = await fetch(`https://panel.yunshuglobal.com:3063/api/searchMagistrate?account=${account}&magistrate=${value}`);
          const data = await response.json();
          setSuggestions2(data);
        } catch (error) {
          console.error('Error fetching suggestions:', error);
        }
      };
    
      const handleSelect2 = (suggestion) => {
        setQuery2(suggestion.name);
        setSelectedSuggestion2(suggestion.Magistrate);
        setSuggestions2([]);
      };


      const handleChange3 = async (e) => {
        const value = e.target.value;
        setQuery3(value);
    
        if (value.trim() === '') {
          setSuggestions3([]);
          return;
        }
    
        try {
          const response = await fetch(`https://panel.yunshuglobal.com:3063/api/searchAuctioneer?account=${account}&auctioneer=${value}`);
          const data = await response.json();
          setSuggestions3(data);
        } catch (error) {
          console.error('Error fetching suggestions:', error);
        }
      };
    
      const handleSelect3 = (suggestion) => {
        setQuery3(suggestion.name);
        setSelectedSuggestion3(suggestion.auctioneer);
        setSuggestions3([]);
      };




      const logout=()=>{
        localStorage.removeItem('email');
        navigate('/login')
      }
  return (
    <div>
        <ToastContainer />
        <div className="homeTop">
            <div className="menuBar">
                <h4 className='menuTitle'>Motor Claims Database</h4>
                {type == '0' &&
                  <div className="menuList">
              
                    <p className='menu' onClick={toHome}>All Claims</p>
                    <p className='menu' onClick={toNew}>New Claim</p>
                    <p className='menu' >Reports</p>
                    <p className='menu' onClick={logout} >Sign out</p>
                </div>
                
                
                }
                {type == '1' &&
                  <div className="menuList">
              
                    <p className='menu' onClick={toHome}>All Claims</p>
                    <p className='menu' onClick={toUsers}>Users</p>
                    <p className='menu' >Individual Report</p>
                    <p className='menu' >Reports</p>
                    <p className='menu' onClick={logout} >Sign out</p>
                </div>
                
                
                }
                {type == '3' &&
                  <div className="menuList">
              
                    <p className='menu' onClick={toHome}>All Claims</p>
                    <p className='menu' >Individual Report</p>

                    <p className='menu' onClick={logout} >Sign out</p>
                </div>
                
                
                }
              
                <div className="phoneMenu">
                    <header className='header'>
                        <div className="menu-icon" onClick={toggleMenu}>
                        <span className="bar"></span>
                        <span className="bar"></span>
                        <span className="bar"></span>
                        </div>

                        <nav className={`nav-menu ${isOpen ? 'open' : ''}`}>
                        <ul>
                            <li onClick={toHome}><a>My Claims</a></li>
                            <li onClick={toNew}><a>New Claim</a></li>
                            <li><a>Reports</a></li>
                            <li onClick={logout}><a>Sign out</a></li>
                        </ul>
                        </nav>
                    </header>
                </div>
            </div>
           
            <div className="searchReport">
                <div className='formInput3'>
                <FloatingLabel className='formInput3' controlId="floatingInputGrid" label="Police officer" onChange={handleChange}>
                    <Form.Control  className='inputSearch' value={query}  type="text" placeholder="Police officer" />
                </FloatingLabel>
                {suggestions.length > 0 && (
                        <ul className='suggestions'>
                        {suggestions.map((suggestion) => (
                            <li key={suggestion.Police} onClick={() => handleSelect(suggestion)}>
                            {suggestion.Police}
                            </li>
                        ))}
                        </ul>
                    )}
                    {selectedSuggestion && <p>Police: {selectedSuggestion}</p>}
                </div>

                <div className='formInput3'>
                <FloatingLabel className='formInput3' controlId="floatingInputGrid" label="Lawyer" onChange={handleChange1}>
                    <Form.Control  className='inputSearch' value={query1}  type="text" placeholder="Lawyer" />
                </FloatingLabel>
                {suggestions1.length > 0 && (
                        <ul className='suggestions'>
                        {suggestions1.map((suggestion) => (
                            <li key={suggestion.Lawyer} onClick={() => handleSelect1(suggestion)}>
                            {suggestion.Lawyer}
                            </li>
                        ))}
                        </ul>
                    )}
                    {selectedSuggestion1 && <p>Lawyer: {selectedSuggestion1}</p>}
                </div>

                <div className='formInput3'>
                <FloatingLabel className='formInput3' controlId="floatingInputGrid" label="Magistrate" onChange={handleChange2}>
                    <Form.Control  className='inputSearch' value={query2}  type="text" placeholder="Magistrate" />
                </FloatingLabel>
                {suggestions2.length > 0 && (
                        <ul className='suggestions'>
                        {suggestions2.map((suggestion) => (
                            <li key={suggestion.Magistrate} onClick={() => handleSelect2(suggestion)}>
                            {suggestion.Magistrate}
                            </li>
                        ))}
                        </ul>
                    )}
                    {selectedSuggestion2 && <p>Magistrate: {selectedSuggestion2}</p>}
                </div>

                <div className='formInput3'>
                <FloatingLabel className='formInput3' controlId="floatingInputGrid" label="Auctioneer" onChange={handleChange3}>
                    <Form.Control  className='inputSearch' value={query3}  type="text" placeholder="Auctioneer" />
                </FloatingLabel>
                {suggestions3.length > 0 && (
                        <ul className='suggestions'>
                        {suggestions3.map((suggestion) => (
                            <li key={suggestion.auctioneer} onClick={() => handleSelect3(suggestion)}>
                            {suggestion.auctioneer}
                            </li>
                        ))}
                        </ul>
                    )}
                    {selectedSuggestion3 && <p>Auctioneer: {selectedSuggestion3}</p>}
                </div>
               
            </div>
            

        </div>
        <div className="homeContainer">
           <h5>Reports</h5>
           <hr />
           <Button color='success' onClick={exportToPdf} style={{marginBottom:'1%'}}>Export as pdf</Button>
           <div className="table-responsive">
                <Table striped bordered hover id="dataTable" border="1" >

                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Date</th>
                            <th scope="col">Registration number</th>
                            <th scope="col">Claimant</th>
                            <th scope="col">Police</th>
                            <th scope="col">Lawyer</th>
                            <th scope="col">Magistrate</th>
                            <th scope="col">Auctioneer</th>
                            <th scope="col">User</th>
                         
                        </tr>
                    </thead>
                    <tbody>
                        {claims.map((val,index)=>{
                            const policyDate = new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(val.OccurenceDate)
                           if(selectedSuggestion == null && selectedSuggestion1 == null && selectedSuggestion2 == null && selectedSuggestion3 == null){
                            return(
                                <tr>
                                    <td>{index+1}</td>
                                    <td>{policyDate}</td>
                                    <td><button  className='tableButton' value={val.Id} >{val.Registration}</button></td>
                                    <td>{val.Claimant}</td>
                               
                                    <td>{val.Police}</td>
                                    <td>{val.Lawyer}</td>
                                    <td>{val.Magistrate}</td>
                                    <td>{val.auctioneer}</td>
                                    <td>{val.FirstName} <td>{val.Surname}</td></td>

                                   
                                    

                                </tr>
                            )
                           

                           }
                           else if(selectedSuggestion == val.Police && selectedSuggestion1 == null && selectedSuggestion2 == null && selectedSuggestion3 == null){
                            return(
                                <tr>
                                    <td>{index+1}</td>
                                    <td>{policyDate}</td>
                                    <td><button  className='tableButton' value={val.Id} >{val.Registration}</button></td>
                                    <td>{val.Claimant}</td>
                               
                                    <td>{val.Police}</td>
                                    <td>{val.Lawyer}</td>
                                    <td>{val.Magistrate}</td>
                                    <td>{val.auctioneer}</td>
                                    <td>{val.FirstName} <td>{val.Surname}</td></td>
                                   
                                    

                                </tr>
                            )
                           }
                           else if(selectedSuggestion == val.Police && selectedSuggestion1 == val.Lawyer && selectedSuggestion2 == null && selectedSuggestion3 == null){
                            return(
                                <tr>
                                    <td>{index+1}</td>
                                    <td>{policyDate}</td>
                                    <td><button  className='tableButton' value={val.Id} >{val.Registration}</button></td>
                                    <td>{val.Claimant}</td>
                               
                                    <td>{val.Police}</td>
                                    <td>{val.Lawyer}</td>
                                    <td>{val.Magistrate}</td>
                                    <td>{val.auctioneer}</td>
                                    <td>{val.FirstName} <td>{val.Surname}</td></td>
                                   
                                    

                                </tr>
                            )
                           }
                           else if(selectedSuggestion == val.Police && selectedSuggestion1 == val.Lawyer && selectedSuggestion2 == val.Magistrate && selectedSuggestion3 == null){
                            return(
                                <tr>
                                    <td>{index+1}</td>
                                    <td>{policyDate}</td>
                                    <td><button  className='tableButton' value={val.Id} >{val.Registration}</button></td>
                                    <td>{val.Claimant}</td>
                               
                                    <td>{val.Police}</td>
                                    <td>{val.Lawyer}</td>
                                    <td>{val.Magistrate}</td>
                                    <td>{val.auctioneer}</td>
                                    <td>{val.FirstName} <td>{val.Surname}</td></td>
                                   
                                    

                                </tr>
                            )
                           }
                           else if(selectedSuggestion == val.Police && selectedSuggestion1 == val.Lawyer && selectedSuggestion2 == val.Magistrate && selectedSuggestion3 == val.auctioneer){
                            return(
                                <tr>
                                    <td>{index+1}</td>
                                    <td>{policyDate}</td>
                                    <td><button  className='tableButton' value={val.Id} >{val.Registration}</button></td>
                                    <td>{val.Claimant}</td>
                               
                                    <td>{val.Police}</td>
                                    <td>{val.Lawyer}</td>
                                    <td>{val.Magistrate}</td>
                                    <td>{val.auctioneer}</td>
                                    <td>{val.FirstName} <td>{val.Surname}</td></td>
                                   
                                    

                                </tr>
                            )
                           }
                           else if(selectedSuggestion == null && selectedSuggestion1 == val.Lawyer && selectedSuggestion2 == null && selectedSuggestion3 == null ){
                            return(
                                <tr>
                                    <td>{index+1}</td>
                                    <td>{policyDate}</td>
                                    <td><button  className='tableButton' value={val.Id} >{val.Registration}</button></td>
                                    <td>{val.Claimant}</td>
                               
                                    <td>{val.Police}</td>
                                    <td>{val.Lawyer}</td>
                                    <td>{val.Magistrate}</td>
                                    <td>{val.auctioneer}</td>
                                    <td>{val.FirstName} <td>{val.Surname}</td></td>
                                   
                                    

                                </tr>
                            )
                           }
                           else if(selectedSuggestion == null && selectedSuggestion1 == val.Lawyer && selectedSuggestion2 == val.Magistrate && selectedSuggestion3 == val.auctioneer){
                            return(
                                <tr>
                                    <td>{index+1}</td>
                                    <td>{policyDate}</td>
                                    <td><button  className='tableButton' value={val.Id} >{val.Registration}</button></td>
                                    <td>{val.Claimant}</td>
                               
                                    <td>{val.Police}</td>
                                    <td>{val.Lawyer}</td>
                                    <td>{val.Magistrate}</td>
                                    <td>{val.auctioneer}</td>
                                    <td>{val.FirstName} <td>{val.Surname}</td></td>
                                   
                                    

                                </tr>
                            )
                           }

                           else if(selectedSuggestion == null && selectedSuggestion1 == null && selectedSuggestion2 == val.Magistrate && selectedSuggestion3 == null){
                            return(
                                <tr>
                                    <td>{index+1}</td>
                                    <td>{policyDate}</td>
                                    <td><button  className='tableButton' value={val.Id} >{val.Registration}</button></td>
                                    <td>{val.Claimant}</td>
                               
                                    <td>{val.Police}</td>
                                    <td>{val.Lawyer}</td>
                                    <td>{val.Magistrate}</td>
                                    <td>{val.auctioneer}</td>
                                    <td>{val.FirstName} <td>{val.Surname}</td></td>
                                   
                                    

                                </tr>
                            )
                           }
                           else if(selectedSuggestion == val.Police && selectedSuggestion1 == null && selectedSuggestion2 == val.Magistrate && selectedSuggestion3 == null){
                            return(
                                <tr>
                                    <td>{index+1}</td>
                                    <td>{policyDate}</td>
                                    <td><button  className='tableButton' value={val.Id} >{val.Registration}</button></td>
                                    <td>{val.Claimant}</td>
                               
                                    <td>{val.Police}</td>
                                    <td>{val.Lawyer}</td>
                                    <td>{val.Magistrate}</td>
                                    <td>{val.auctioneer}</td>
                                    <td>{val.FirstName} <td>{val.Surname}</td></td>
                                   
                                    

                                </tr>
                            )
                           }

                           else if(selectedSuggestion == null && selectedSuggestion1 == null && selectedSuggestion2 == null && selectedSuggestion3 ==val.auctioneer){
                            return(
                                <tr>
                                    <td>{index+1}</td>
                                    <td>{policyDate}</td>
                                    <td><button  className='tableButton' value={val.Id} >{val.Registration}</button></td>
                                    <td>{val.Claimant}</td>
                               
                                    <td>{val.Police}</td>
                                    <td>{val.Lawyer}</td>
                                    <td>{val.Magistrate}</td>
                                    <td>{val.auctioneer}</td>
                                    <td>{val.FirstName} <td>{val.Surname}</td></td>
                                   
                                    

                                </tr>
                            )
                           }
                            
                        })}
                    </tbody>
                </Table>
            </div>
        </div>
      
    </div>
  )
}
